import styled from '@emotion/styled';
import { TopHeaderForBuyer } from 'ui/components/panes/Header/TopHeaderForBuyer';
import { Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { usePasswordReset } from './usePasswordReset';
import { FormInput } from 'ui/components/elements/FormInput/FormInput';
import { FormLabel } from 'ui/components/elements/FormLabel/FormLabel';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { mqMin } from 'utils/responsive';

const InputWrapper = styled.div`
    position: relative;
    display: flex;
    gap: 12px;
    align-items: center;
    margin-block: 16px 50px;
    input {
        width: min(560px, 90vw);
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 40px;
`;

const FormWrapper = styled.div`
    max-width: min(600px, 90vw);
    margin-inline: auto;
`;

const Button = styled.button`
    width: 100%;
    min-width: 200px;
    padding: 18px;
    outline: none;
    border-radius: 60px;
    background-color: #ed793e;
    font-size: var(--font-x-large);
    font-weight: var(--font-bold);
    color: #fff;
    white-space: nowrap;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.2 : 1)};

    ${mqMin('NARROW')} {
        width: 200px;
    }

    &:not(:disabled):hover {
        opacity: 0.7;
    }
`;

export const PasswordReset = () => {
    const {
        control,
        formState: { errors },
        requesting,
        showSnackbar,
        setShowSnackbar,
        submit,
    } = usePasswordReset();

    const navigate = useNavigate();
    return (
        <Wrapper>
            <TopHeaderForBuyer />
            <FormWrapper>
                <FormLabel title="パスワード" isRequired />
                <SnackBar
                    open={showSnackbar}
                    setOpen={setShowSnackbar}
                    message="パスワードを再設定しました。再度ログインしてください"
                    callback={() => navigate('/buyer/login/')}
                />
                <InputWrapper>
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                            <FormInput
                                {...field}
                                type="password"
                                placeholder="新しいパスワードを入力してください"
                                hasError={!!errors.password?.message}
                            />
                        )}
                    />
                </InputWrapper>
                <ButtonWrapper>
                    <Button disabled={requesting} onClick={submit}>
                        再設定する
                    </Button>
                </ButtonWrapper>
            </FormWrapper>
        </Wrapper>
    );
};
